import React from 'react';

import { Checkbox as AntdCheckbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';

import { FilterDashboardVideoTutoriel } from '../../utils/type';

interface FilterProps {
  setFilter: (value: Partial<FilterDashboardVideoTutoriel>) => void;
  filter: Partial<FilterDashboardVideoTutoriel>;
}

export default function Filter({
  filter,
  setFilter,
}: FilterProps): React.ReactElement {
  const { valid } = filter;

  function setDisplayInvalidVideo(event: CheckboxChangeEvent) {
    setFilter({
      ...filter,
      valid: !event.target.checked,
    });
  }

  return (
    <div className="dashboard-header-filter">
      <AntdCheckbox checked={!valid} onChange={setDisplayInvalidVideo}>
        Afficher les vidéos inactives
      </AntdCheckbox>
    </div>
  );
}
